import type {
  RecurringTaskListParams,
  RecurringTaskListResponse
} from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import qs from 'qs'
import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { convertPropsToParams } from 'screens/Todos/NewDashboard/hooks/utils'
import type { AllManagerFilters } from '../components/ManagerFilters/ManagerFilters'
import type { SortObject } from '../components/ManageTasksTable'

export const GET_RECURRING_TASKS = `/api/list/recurring-tasks/new`

export type UseRecurringTaskProps = {
  recurringTaskId?: string
  onDeleteSuccess?: () => void
  filters?: AllManagerFilters
  sort?: SortObject
}

export type PageProps = { index: number; size: number }

export const PAGE_SIZE = 10
const initialPage = { index: 1, size: PAGE_SIZE }

const useRecurringTasks = ({
  filters = {},
  sort = {}
}: UseRecurringTaskProps) => {
  const convertedParams = convertAllManagerFiltersToQueryParams(filters)

  const [page, setPage] = useState<PageProps>(initialPage)

  useEffect(() => {
    setPage(initialPage)
  }, [filters])

  const { isLoading, isFetching, isFetched, data, refetch } =
    useQuery<RecurringTaskListResponse>(
      ['recurring-tasks', convertedParams, page, sort],
      () =>
        getQuery({
          ...convertedParams,
          pagination: {
            itemsPerPage: page.size,
            page: page.index,
            sort
          }
        }),
      {
        keepPreviousData: true,
        refetchOnWindowFocus: false
      }
    )

  return {
    isLoading: (isLoading || isFetching) && !isFetched,
    recurringTasks: data?.data,
    pagination: data?.pagination,
    refetch,
    setPage
  }
}

const getQuery = (props: RecurringTaskListParams) => {
  const queryParams = qs.stringify(props)

  const data = getJSON({ url: `${GET_RECURRING_TASKS}?${queryParams}` })

  return data
}

const convertAllManagerFiltersToQueryParams = (
  filters: AllManagerFilters
): RecurringTaskListParams => ({
  ...convertPropsToParams(filters),
  taskTypes: filters.type,
  recurrence: filters.frequency
})

export default useRecurringTasks
